function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import TitleAdvancedConfig from "segments/desktop/core-components/title/advanced-field-config";
import VerticalTimerTabsAdvancedConfig from "segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread(_object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig), {
        title: {
            label: "Title",
            type: FIELD_TYPES.NESTED,
            fields: TitleAdvancedConfig
        },
        advancedTitleConfig: _object_spread_props(_object_spread({}, VerticalTimerTabsAdvancedConfig.title), {
            label: "Tab Title"
        }),
        tabContent: {
            type: FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: FullParagraphAdvancedFieldsConfig
        },
        advancedProcessTabs: {
            type: FIELD_TYPES.NESTED,
            label: "Process tabs",
            fields: {
                titleConfig: {
                    type: FIELD_TYPES.NESTED,
                    label: "Asset Title",
                    fields: TitleAdvancedConfig
                },
                autoTransition: {
                    type: FIELD_TYPES.TEXT,
                    label: "Auto Transition (milliseconds)"
                },
                scrollOnTabClick: {
                    type: FIELD_TYPES.BOOLEAN,
                    label: "Should scroll to content on tab click"
                },
                scrollSpeed: {
                    type: FIELD_TYPES.TEXT,
                    label: "Scroll speed on tab click"
                },
                distanceFromTop: {
                    type: FIELD_TYPES.TEXT,
                    label: "Distance to stop when scrolling (fixed header height)"
                }
            }
        },
        arrowSize: VerticalTimerTabsAdvancedConfig.arrowSize
    }), AssetAdvancedConfig)
};
